import {
  formatPrecisaoFloat,
  formatPrice,
  unformatPrice,
} from "../../../../utils";
import {
  Grid,
  CurrencyInput,
  Typography,
  TextFielDecimalNumbers,
} from "../../../../components";
import {
  calculoDesconto,
  formatProdutosTotalizadores,
  totalVenda,
} from "../add-nf-saida";

const ResumoTotal = ({
  nfSaidaId,
  nfSaida,
  nfSaidaEntity,
  setNfSaida,
  nfSaidaProdutos,
  setNfSaidaProdutos,
  abaValue,
  setNfSaidaPagamentos,
  permissaoEditarDesconto,
}) => {
  const handleInputFrete = (event) => {
    if (nfSaidaProdutos?.length) {
      const valor = unformatPrice(event.target.value);
      if (
        parseFloat(nfSaida[event.target.name].toFixed(2)) !==
        formatPrecisaoFloat(parseFloat(valor))
      ) {
        const name = "frete";
        const totalNota = totalVenda(nfSaida, nfSaidaProdutos, name);
        const listItensFrete = formatProdutosTotalizadores(
          name,
          nfSaidaProdutos,
          valor,
          totalNota
        );
        setNfSaidaProdutos(listItensFrete);
        nfSaidaEntity.setChangeItens(nfSaidaId, listItensFrete);
        setNfSaidaPagamentos([]);
        nfSaidaEntity.setChangePagamentos([]);
        setNfSaida(nfSaidaEntity);
      }
    }
  };

  const handleInputDespesas = (event) => {
    if (nfSaidaProdutos?.length) {
      const name = "despesas";
      const valor = unformatPrice(event.target.value);
      const totalNota = totalVenda(nfSaida, nfSaidaProdutos, name);
      const listItensDespesas = formatProdutosTotalizadores(
        name,
        nfSaidaProdutos,
        valor,
        totalNota
      );
      setNfSaidaProdutos(listItensDespesas);
      nfSaidaEntity.setChangeItens(nfSaidaId, listItensDespesas);
      setNfSaidaPagamentos([]);
      nfSaidaEntity.setChangePagamentos([]);
      setNfSaida(nfSaidaEntity);
    }
  };

  const handleInputDesconto = (event) => {
    if (nfSaidaProdutos?.length) {
      const name = "desconto";
      const valor = unformatPrice(event.target.value);
      if (
        parseFloat(nfSaida[event.target.name].toFixed(2)) !==
        formatPrecisaoFloat(parseFloat(valor))
      ) {
        const totalNota = totalVenda(nfSaida, nfSaidaProdutos, name);
        const nfSaidaTemp = {
          ...nfSaida,
          [event.target.name]: valor || 0,
        };
        if (event.target.name === "desconto") {
          nfSaidaTemp.descontoPorcentagem = calculoDesconto(
            nfSaidaProdutos,
            nfSaidaTemp,
            false
          );
          const listItensDesconto = formatProdutosTotalizadores(
            name,
            nfSaidaProdutos,
            valor,
            totalNota
          );
          setNfSaidaProdutos(listItensDesconto);
          nfSaidaEntity.setChangeItens(nfSaidaId, listItensDesconto);
          setNfSaidaPagamentos([]);
          nfSaidaEntity.setChangePagamentos([]);
          setNfSaida(nfSaidaEntity);
        } else {
          nfSaidaTemp.desconto = calculoDesconto(nfSaidaProdutos, nfSaidaTemp);
          const listItensDesconto = formatProdutosTotalizadores(
            name,
            nfSaidaProdutos,
            nfSaidaTemp?.desconto,
            totalNota
          );
          setNfSaidaProdutos(listItensDesconto);
          nfSaidaEntity.setChangeItens(nfSaidaId, listItensDesconto);
          setNfSaidaPagamentos([]);
          nfSaidaEntity.setChangePagamentos([]);
          setNfSaida(nfSaidaEntity);
        }
      }
    }
  };

  const nextFocusInput = (event) => {
    if (event.keyCode === 13) {
      const { form } = event.target;
      const arrayInput = Array.from(form.elements).filter(
        (element) => element.tagName == "INPUT"
      );
      const index = arrayInput.indexOf(event.target);
      let element = arrayInput[index + 1];
      if (element?.disabled) {
        element = arrayInput[index + 2];
      }
      if (element) {
        element.focus();
      } else {
        arrayInput[index].blur();
      }
      event.preventDefault();
    }
  };

  return (
    <form>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        className="mx-3"
        columns={15}
      >
        <Grid
          item
          xs={2}
          className="d-flex align-items-center justify-content-end"
        >
          <span className="me-2">Subtotal:</span>
          <span className="badge bg-primary bg-gradient bg-gradient text-wrap p-2">
            <Typography color="white" style={{ fontWeight: 700 }}>
              {formatPrice(nfSaida?.totalMercadoria || 0) || "R$ 0,00"}
            </Typography>
          </span>
        </Grid>
        <Grid
          item
          xs={5}
          className="d-flex align-items-center justify-content-end gap-2"
        >
          <span className="me-2">Desconto:</span>
          <TextFielDecimalNumbers
            id="descontoPorcentagem"
            name="descontoPorcentagem"
            variant="outlined"
            disabled={
              nfSaidaId ||
              abaValue !== 0 ||
              (nfSaida?.documentoImportado && !permissaoEditarDesconto) ||
              nfSaida?.descontoItem
            }
            margin="none"
            size="small"
            value={nfSaida?.descontoPorcentagem ?? 0}
            onBlur={handleInputDesconto}
            onKeyDown={nextFocusInput}
          />
          <CurrencyInput
            id="desconto"
            name="desconto"
            variant="outlined"
            disabled={
              nfSaidaId ||
              abaValue !== 0 ||
              (nfSaida?.documentoImportado &&
                !permissaoEditarDesconto.temPermisao(
                  "nf-saida-editar-desconto"
                )) ||
              nfSaida?.descontoItem
            }
            margin="none"
            size="small"
            value={nfSaida.desconto ?? 0}
            onBlur={handleInputDesconto}
            onKeyDown={nextFocusInput}
          />
        </Grid>
        <Grid
          item
          xs={3}
          className="d-flex align-items-center justify-content-end"
        >
          <span className="me-2">Frete:</span>
          <CurrencyInput
            id="frete"
            name="frete"
            variant="outlined"
            disabled={
              nfSaidaId ||
              (abaValue !== 0 && abaValue !== 4) ||
              nfSaida?.documentoImportado ||
              nfSaida?.freteItem
            }
            margin="none"
            size="small"
            value={nfSaida?.frete}
            onBlur={handleInputFrete}
            onKeyDown={nextFocusInput}
          />
        </Grid>
        <Grid
          item
          xs={3}
          className="d-flex align-items-center justify-content-end"
        >
          <span className="me-2">Despesas:</span>
          <CurrencyInput
            id="despesas"
            name="despesas"
            variant="outlined"
            disabled={
              nfSaidaId ||
              abaValue !== 0 ||
              nfSaida?.documentoImportado ||
              nfSaida?.despesasItem
            }
            margin="none"
            size="small"
            value={nfSaida?.despesas}
            onBlur={handleInputDespesas}
            onKeyDown={nextFocusInput}
          />
        </Grid>
        <Grid item xs={2} className="d-flex align-items-center">
          <span className="me-2">Total:</span>
          <span className="badge bg-primary bg-gradient bg-gradient text-wrap p-2">
            <Typography color="white" style={{ fontWeight: 700 }}>
              {formatPrice(nfSaida?.totalVenda || 0) || "R$ 0,00"}
            </Typography>
          </span>
        </Grid>
      </Grid>
    </form>
  );
};

export default ResumoTotal;
